export const springIntoShapeProductS = {
    mainPromoHeadline:
      "products.product.promotions.springIntoShape.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.springIntoShape.heading.image",
      title: "products.productS.promotions.springIntoShape.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.springIntoShape.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.springIntoShape.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.springIntoShape.footer",
    total: {
      headline: "products.productS.promotions.springIntoShape.total.headline",
      priceBefore: "products.productS.promotions.springIntoShape.total.priceBefore",
      priceAfter: "products.productS.promotions.springIntoShape.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.springIntoShape.discount.heading",
      title: "products.productS.promotions.springIntoShape.discount.title",
      amount: "products.productS.promotions.springIntoShape.discount.amount",
      code: {
        description:
          "products.productS.promotions.springIntoShape.discount.code.description",
        promoCode:
          "products.productS.promotions.springIntoShape.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.springIntoShape.items.item1.title",
        description:
          "products.productS.promotions.springIntoShape.items.item1.description",
        priceBefore:
          "products.productS.promotions.springIntoShape.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.springIntoShape.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.springIntoShape.items.item2.title",
        description:
          "products.productS.promotions.springIntoShape.items.item2.description",
        priceBefore:
          "products.productS.promotions.springIntoShape.items.item2.priceBefore",
        priceAfter: "products.productS.promotions.springIntoShape.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.springIntoShape.items.item3.title",
        description:
          "products.productS.promotions.springIntoShape.items.item3.description",
        priceBefore:
          "products.productS.promotions.springIntoShape.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.springIntoShape.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.springIntoShape.items.item4.title",
        description:
          "products.productS.promotions.springIntoShape.items.item4.description",
        priceBefore:
          "products.productS.promotions.springIntoShape.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.springIntoShape.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.springIntoShape.items.item5.title",
        description:
          "products.productS.promotions.springIntoShape.items.item5.description",
        priceBefore:
          "products.productS.promotions.springIntoShape.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.springIntoShape.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateSpringIntoShapeProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateSpringIntoShape.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateSpringIntoShape.heading.image",
      title: "products.productS.promotions.flatrateSpringIntoShape.heading.title",
    },
    footer: "products.productS.promotions.flatrateSpringIntoShape.footer",
    total: {
      headline:
        "products.productS.promotions.flatrateSpringIntoShape.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateSpringIntoShape.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateSpringIntoShape.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.springIntoShape.discount.heading",
      title: "products.productS.promotions.flatrateSpringIntoShape.discount.title",
      amount: "products.productS.promotions.flatrateSpringIntoShape.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateSpringIntoShape.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateSpringIntoShape.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item1.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item2.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item3.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item4.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item5.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productS.promotions.flatrateSpringIntoShape.items.item6.title",
        description:
          "products.productS.promotions.flatrateSpringIntoShape.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateSpringIntoShape.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSpringIntoShape.items.item6.priceAfter",
      },
    },
  };
  
  export const springIntoShapeProductX = {
    mainPromoHeadline:
      "products.productX.promotions.springIntoShape.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.springIntoShape.heading.image",
      title: "products.productX.promotions.springIntoShape.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.springIntoShape.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.springIntoShape.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.springIntoShape.footer",
    total: {
      headline: "products.productX.promotions.springIntoShape.total.headline",
      priceBefore: "products.productX.promotions.springIntoShape.total.priceBefore",
      priceAfter: "products.productX.promotions.springIntoShape.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.springIntoShape.discount.heading",
      title: "products.productX.promotions.springIntoShape.discount.title",
      amount: "products.productX.promotions.springIntoShape.discount.amount",
      code: {
        description:
          "products.productX.promotions.springIntoShape.discount.code.description",
        promoCode:
          "products.productX.promotions.springIntoShape.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.springIntoShape.items.item1.title",
        description:
          "products.productX.promotions.springIntoShape.items.item1.description",
        priceBefore:
          "products.productX.promotions.springIntoShape.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.springIntoShape.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.springIntoShape.items.item2.title",
        description:
          "products.productX.promotions.springIntoShape.items.item2.description",
        priceBefore:
          "products.productX.promotions.springIntoShape.items.item2.priceBefore",
        priceAfter: "products.productX.promotions.springIntoShape.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.springIntoShape.items.item3.title",
        description:
          "products.productX.promotions.springIntoShape.items.item3.description",
        priceBefore:
          "products.productX.promotions.springIntoShape.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.springIntoShape.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.springIntoShape.items.item4.title",
        description:
          "products.productX.promotions.springIntoShape.items.item4.description",
        priceBefore:
          "products.productX.promotions.springIntoShape.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.springIntoShape.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.springIntoShape.items.item5.title",
        description:
          "products.productX.promotions.springIntoShape.items.item5.description",
        priceBefore:
          "products.productX.promotions.springIntoShape.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.springIntoShape.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateSpringIntoShapeProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateSpringIntoShape.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateSpringIntoShape.heading.image",
      title: "products.productX.promotions.flatrateSpringIntoShape.heading.title",
    },
    footer: "products.productX.promotions.flatrateSpringIntoShape.footer",
    total: {
      headline:
        "products.productX.promotions.flatrateSpringIntoShape.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateSpringIntoShape.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateSpringIntoShape.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.springIntoShape.discount.heading",
      title: "products.productX.promotions.flatrateSpringIntoShape.discount.title",
      amount: "products.productX.promotions.flatrateSpringIntoShape.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateSpringIntoShape.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateSpringIntoShape.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item1.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item2.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item3.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item4.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item5.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productX.promotions.flatrateSpringIntoShape.items.item6.title",
        description:
          "products.productX.promotions.flatrateSpringIntoShape.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateSpringIntoShape.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSpringIntoShape.items.item6.priceAfter",
      },
    },
  };
  